module.exports = __webpack_public_path__ + "img/product-preview-8.848e89a.png";